<template>
    <ListenerFavourites v-if="isListenerMobile" />
    <Favourites v-else />
</template>

<script>
import Favourites from './Favourites.vue'
import ListenerFavourites from './ListenerFavourites.vue'

export default {
    name: 'FavouritesEntry',
    components: {
        Favourites,
        ListenerFavourites
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
